import {Injectable} from '@angular/core';

@Injectable()
export class DashboardCacheService {

    private cache = new Map<any, any>();

    constructor() {
    }

    putData(key, dataIdentifier, data) {
        if (!this.cache[key]) {
            this.cache[key] = {};
        }
        if (!this.cache[key][dataIdentifier]) {
            this.cache[key][dataIdentifier] = {};
        }

        const deepCopy = JSON.parse(JSON.stringify(data));
        this.cache[key][dataIdentifier] = deepCopy;
    }

    getData(key, dataIdentifier) {
        if ((this.cache[key])
            && (this.cache[key][dataIdentifier])) {
            return this.cache[key][dataIdentifier];
        } else {
            return null;
        }
    }
}
